import {
    FIND_PRODUCTS_BY_ID_CATEGORY,
    FIND_PRODUCTS_BY_ID_CATEGORY_SUCCESS,
    FIND_PRODUCTS_BY_ID_CATEGORY_API_ERROR,
} from "./actionTypes"


const initialState = {
    loading: true,
    loading_form: false,
    error: false,
    message: '',

    row: null,
    id: 0,
}

const productsCategory = (state = initialState, action) => {

    switch (action.type) {
        case FIND_PRODUCTS_BY_ID_CATEGORY:
            state = {
                ...state,
                loading: true
            }
            break
        case FIND_PRODUCTS_BY_ID_CATEGORY_SUCCESS:
            state = {
                ...state,
                message: action.payload.message,
                error: action.payload.error,
                row: action.payload.data,
                loading: false
            }
            break
        case FIND_PRODUCTS_BY_ID_CATEGORY_API_ERROR:
            state = {...state, error: action.payload, loading: false}
            break
        default:
            state = {...state}
            break
    }

    return state
}
export default productsCategory
